import { ITooltipOption } from '../../KubitTooltip/globalTooltips';

export const significanceLiftInfo: ITooltipOption = {
  content: (
    <p>
      <strong>Description</strong>: Lift, or relative performance, quantifies
      how much the <strong>Variant</strong> performs compared to{' '}
      <strong>Control</strong>. It is computed as the <strong>Delta</strong>{' '}
      divided by Control&apos;s Mean and presented as %, i.e. Delta / Mc %
      <br />
      <br />
      <strong>Range</strong>: Positive indicates <strong>Variant</strong>{' '}
      performed better, negative indicates worse.
      <br />
      <br />
      <strong>Interpretation</strong>: Higher lift values show greater
      improvement of the <strong>Variant</strong> over the{' '}
      <strong>Control</strong>.
    </p>
  ),
};
export const significanceLiftConfidenceIntervalInfo: ITooltipOption = {
  content: (
    <p>
      <strong>Description</strong>: Lift CI shows the potential range of the{' '}
      <strong>Lift</strong>.
      <br />
      <br />
      <strong>Range</strong>: It indicates the predicted upper and lower bound
      of <strong>Lift</strong> in reality.
      <br />
      <br />
      <strong>Interpretation</strong>: Lift CI helps gauge uncertainty in
      measured outcomes or impacts, providing a statistical boundary for
      expected <strong>Lift</strong>.
    </p>
  ),
};
export const significanceStatSigInfo: ITooltipOption = {
  content: (
    <p>
      <strong>Description</strong>: Whether the Lift is statistically
      significant, with the result <strong>p-value</strong>.
      <br />
      <br />
      <strong>Range</strong>: True | False, with result <strong>p-value</strong>{' '}
      goes between 0 to 1.
      <br />
      <br />
      <strong>Interpretation</strong>: If the result <strong>p-value</strong> is
      less than the desired (e.g. 0.05), it means our result is statistically
      significant, and we should consider rejecting the null hypothesis.
    </p>
  ),
};
export const significanceSampleSizeInfo: ITooltipOption = {
  content: (
    <p>
      <strong>Description</strong>: the number of subjects or observations in
      each group. It affects result reliability.
      <br />
      <br />
      <strong>Range</strong>: Depends on the criteria applied; usually, bigger
      is better.
      <br />
      <br />
      <strong>Interpretation</strong>: Larger sample sizes make results more
      reliable and differences easier to detect. Smaller sizes may be less
      reliable and harder to show differences.
    </p>
  ),
};
export const significanceMeanInfo: ITooltipOption = {
  content: (
    <p>
      <strong>Description</strong>: The mean is the average of the{' '}
      <strong>Measurement</strong> (like clicks, purchases or conversion) for
      the group tested.
      <br />
      <br />
      <strong>Range</strong>: Varies depending on the measurement and group
      characteristics.
      <br />
      <br />
      <strong>Interpretation</strong>: The mean helps compare average
      performance between <strong>Control</strong> and <strong>Variant</strong>,
      revealing differences or similarities in measured outcomes.
    </p>
  ),
};
export const significanceStdDeviationInfo: ITooltipOption = {
  content: (
    <p>
      <strong>Description</strong>: Standard deviation measures how spread out
      the Measurement in a set are. It shows whether the Measurements are close
      to the average (<strong>Mean</strong>) or scattered far from it.
      <br />
      <br />
      <strong>Range</strong>: Can vary from a small number (close to zero) to a
      larger number.
      <br />
      <br />
      <strong>Interpretation</strong>: A small standard deviation means the
      Measurements are close to the average. A large standard deviation means
      the numbers are spread out over a wider range.
    </p>
  ),
};
export const significanceDeltaInfo: ITooltipOption = {
  content: (
    <p>
      <strong>Description</strong>: Delta, or absolute performance, shows the
      exact difference of <strong>Mean</strong> between Control and Variant. It
      focuses only on the actual change, not on how it compares to other
      factors.
      <br />
      <br />
      <strong>Range</strong>: It can be positive or negative, depending on
      whether there is an improvement or a decline.
      <br />
      <br />
      <strong>Interpretation</strong>:
      <br />
      Positive Delta: Performance has improved.
      <br />
      Negative Delta: Performance has declined.
      <br />
      Zero Delta: No change in performance.
    </p>
  ),
};
export const significancePowerInfo: ITooltipOption = {
  content: (
    <p>
      <strong>Description</strong>: Statistical <strong>Power</strong> indicates
      how likely that a true effect is detected if there is one. Number of
      Experiments (tests) shows the number of tests conducted for this analysis.
      <br />
      <br />
      <strong>Range</strong>: 0 to 1 for Power; any positive number for Number
      of Experiments.
      <br />
      <br />
      <strong>Interpretation</strong>: Higher Power means more likely that a
      true effect is detected. More Number of Experiments (tests) make the power
      estimate more reliable.
    </p>
  ),
};
export const significanceWelchTestInfo: ITooltipOption = {
  content: (
    <p>
      Test Score (Welch&apos;s t-test)
      <br />
      <strong>Description</strong>: Measures the <strong>Delta</strong> between
      Control and Variant relative to the spread or variability of their scores.
      <br />
      <br />
      <strong>Range</strong>: Any real number.
      <br />
      <br />
      <strong>Interpretation</strong>: A higher <strong>Test Score</strong>{' '}
      indicates a greater difference between groups.
    </p>
  ),
};
export const significanceChiSquareInfo: ITooltipOption = {
  content: (
    <p>
      Test Score (Chi-Square Statistic)
      <br />
      <strong>Description</strong>: Treat funnel conversion as a boolean
      (categorical variable) for each subject (converted = True or False) and
      measures how good the test is at making correct predictions.
      <br />
      <br />
      <strong>Range</strong>: 0 to Infinity.
      <br />
      <br />
      <strong>Interpretation</strong>: Larger values suggest higher accuracy and
      reliability of the test (making correct predictions).
    </p>
  ),
};
